import React from 'react';

import './NoSupport.scss';
import { FIRST_DAY, LAST_DAY, YEAR } from '../../constants';

const NoSupport = () => (
  <div id="no-support">
    <div className="container">
      <div className="home">
        <div />
        <div className="home-middle">
          <div className="home-middle-first-row">
            <div className="middle-year-left">{YEAR}</div>
            <div className="logo">
              <img alt="Openslava Logo" className="logo-image" src="imgs/logo-icon.png" />
            </div>
            <div className="middle-year-right">{YEAR}</div>
          </div>
          <div className="home-middle-second-row">
            <div className="info-icons">
              <i className="fas fa-calendar-alt icon" />
              <i className="fas fa-map icon" />
            </div>
            <div className="info-text">
              <div>
                OCTOBER {FIRST_DAY} - {LAST_DAY}, {YEAR}
              </div>
              <div>BRATISLAVA, SLOVAKIA</div>
            </div>
          </div>
          <div className="home-middle-third-row">
            OpenSlava web page not available, please use a different browser. We apologize for any
            inconvenience.
          </div>
        </div>
        <div className="home-bottom">
          <div className="home-bottom-left">
            <span>ACCENTURE CONFERENCE ON</span>
            <span className="bold-text">EMERGING TECHNOLOGIES</span>
            <span className="bold-text">AND OPEN SOURCE</span>
          </div>
          <div className="home-bottom-right">
            <div className="info-icons">
              <i className="fas fa-calendar-alt icon" />
              <i className="fas fa-map icon" />
            </div>
            <div className="info-text">
              <span>
                OCTOBER {FIRST_DAY} - {LAST_DAY}, {YEAR}
              </span>
              <span>BRATISLAVA, SLOVAKIA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NoSupport;
